import React, { useEffect, useState } from 'react';
import SystemAlertService from '../../Services/SystemAlertService';
import { announceSeverity } from './homeHelpers';

function HomeAnnouncements() {
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    SystemAlertService.GetSystemAlerts()
      .then((result) => setAlerts(SystemAlertService.ConvertDBItemList(result)))
      .catch(() => setAlerts([]));
  }, []);

  const handleDismiss = (alertId) => {
    setDismissed((prev) => [...prev, alertId]);
    SystemAlertService.DismissSystemAlert(alertId);
  };

  const visible = alerts.filter((a) => !dismissed.includes(a.AlertId));
  if (!visible.length) return null;

  return (
    <>
      {visible.map((a) => {
        const sev = announceSeverity(a.SeverityLevel);
        return (
          <div key={a.AlertId} className={'home-announce' + (sev.cls ? ' ' + sev.cls : '')} role="status">
            <span className="an-ic"><i className={sev.icon} /></span>
            <div className="an-body">
              <span className="an-title">{a.Title}</span>
              <span className="an-text">
                {a.Message}
                {a.LinkUrl ? (
                  <a className="an-link" href={a.LinkUrl} target="_blank" rel="noopener noreferrer">
                    {' '}More info…
                  </a>
                ) : null}
              </span>
            </div>
            {a.IsDismissible ? (
              <button className="an-dismiss" onClick={() => handleDismiss(a.AlertId)} aria-label="Dismiss announcement">
                <i className="fa-solid fa-xmark" />
              </button>
            ) : null}
          </div>
        );
      })}
    </>
  );
}

export default HomeAnnouncements;
